module.exports = __webpack_public_path__ + "static/media/065-pinup.9874cd04.svg";